import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isVisible: false,  // Whether the modal is visible or not
  message: '',       // Optional message for the alert modal
  type:''            // 'success' or 'failure'
};

const alertModalSlice = createSlice({
  name: 'alertModal',
  initialState,
  reducers: {
    showModal: (state, action) => {
      state.isVisible = true;
      // state.message = action.payload;  // Set the message when showing the modal
      state.message = action.payload.message;  // Set the message when showing the modal
      state.type = action.payload.type;        
    },
    hideModal: (state) => {
      state.isVisible = false;
      state.message = ''; // Reset the message when hiding the modal
      state.type = '';    // Reset the type
    },
  },
});

export const { showModal, hideModal } = alertModalSlice.actions;
export default alertModalSlice.reducer;